// extracted by mini-css-extract-plugin
export default {"wrapper":"GPcd6","arrow":"HRk6E","icon":"BkvPs","price":"SvXxC","small":"msuQu"};